"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSentryErrorBoundary = void 0;
var tslib_1 = require("tslib");
var React = require("react");
function withSentryErrorBoundary(ComponentToWrap, options, ErrorStateComponent) {
    return /** @class */ (function (_super) {
        tslib_1.__extends(SentryErrorBoundary, _super);
        function SentryErrorBoundary() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.state = {
                error: null,
            };
            return _this;
        }
        SentryErrorBoundary.prototype.getLazySentry = function () {
            return new this.props.host.LazySentry(tslib_1.__assign(tslib_1.__assign({ dsn: options.dsn }, options.config), { release: this.props.sentryRelease }));
        };
        SentryErrorBoundary.prototype.getRavenUserContextOverrides = function () {
            return this.props.ravenUserContextOverrides;
        };
        SentryErrorBoundary.prototype.componentDidCatch = function (error) {
            if (this.state.error === null) {
                this.setState({ error: error });
            }
            var sentryInstance = this.getLazySentry();
            if (!sentryInstance) {
                return;
            }
            if (options.tags) {
                sentryInstance.configureScope(function (scope) {
                    Object.keys(options.tags).forEach(function (tag) {
                        scope.setTag(tag, options.tags[tag]);
                    });
                });
            }
            var userContextOverrides = this.getRavenUserContextOverrides();
            if (options.userContext || userContextOverrides) {
                sentryInstance.configureScope(function (scope) {
                    scope.setUser(tslib_1.__assign(tslib_1.__assign({}, options.userContext), userContextOverrides));
                });
            }
            sentryInstance.captureException(error);
        };
        SentryErrorBoundary.prototype.render = function () {
            return this.state.error && ErrorStateComponent ? (React.createElement(ErrorStateComponent, tslib_1.__assign({ error: this.state.error }, this.props))) : (React.createElement(ComponentToWrap, tslib_1.__assign({}, this.props)));
        };
        return SentryErrorBoundary;
    }(React.Component));
}
exports.withSentryErrorBoundary = withSentryErrorBoundary;
//# sourceMappingURL=sentryErrorBoundary.js.map